import { toast } from "react-toastify";
import { BaseValue } from "./base-value";

type ToastMessageType = "error" | "success";

export class ToastMessage extends BaseValue<{
  message: string;
  messageType: ToastMessageType;
}> {
  messageType() {
    return this.value.messageType;
  }

  show() {
    switch (this.messageType()) {
      case "error":
        toast.error(this.value.message);
        break;
      case "success":
        toast.success(this.value.message);
        break;
    }
  }

  static error(msg: string) {
    return new ToastMessage({
      message: msg,
      messageType: "error",
    });
  }

  static enexpectedError() {
    return new ToastMessage({
      message:
        "予期せぬエラーが発生したため、公開することができませんでした。時間をおいてから、再度お試しください。",
      messageType: "error",
    });
  }

  static retryable() {
    return new ToastMessage({
      message:
        "通信に失敗しました。ネットワーク接続などをご確認の上、再実行してください。",
      messageType: "error",
    });
  }
}
